'use client'

import Link from "next/link"

import { marketingConfig } from "@/config/marketing"
import { cn } from "@/lib/utils"
import { buttonVariants } from "@/components/ui/button"
import { MainNav } from "@/components/main-nav"
import { SiteFooter } from "@/components/site-footer"
import { Background } from "@/components/background"
import { useEffect, useState } from "react"
import { useRouter } from "next/navigation"
import Devhunt from "@/components/devhunt"

interface MarketingLayoutProps {
  children: React.ReactNode
}

export default function MarketingLayout({
  children,
}: MarketingLayoutProps) {

  const router = useRouter();
  const [isHeaderTransparent, setIsHeaderTransparent] = useState(true);

  // Prefetch high-priority routes the user is likely to navigate to
  useEffect(() => {
    router.prefetch('/login');
    router.prefetch('/docs');
    router.prefetch('/careers');
    router.prefetch('/templates');
  }, [router]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setIsHeaderTransparent(scrollTop === 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const [bannerVisible, setBannerVisible] = useState(true);

  return (
    <div className="flex min-h-screen flex-col">
      <Background />
      {bannerVisible && (
        <div className="relative z-50 overflow-hidden bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-500 text-white text-center py-2.5 px-4 text-sm font-medium">
          {/* Animated shimmer overlay */}
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent animate-shimmer pointer-events-none" />
          <span className="relative inline-flex items-center gap-2">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-white"></span>
            </span>
            New — AI Website Builder, Visual Workflow Builder & Template Marketplace are live!
          </span>
          <button
            onClick={() => setBannerVisible(false)}
            className="absolute right-4 top-1/2 -translate-y-1/2 flex h-5 w-5 items-center justify-center rounded-full bg-white/10 text-white/90 hover:bg-white/20 hover:text-white transition-all"
            aria-label="Dismiss banner"
          >
            <svg className="h-3 w-3" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
          </button>
        </div>
      )}
      <header
        className={`z-40 ${
          isHeaderTransparent
            ? "bg-transparent"
            : "bg-white/70 backdrop-blur-xl border-b border-slate-200/60 shadow-sm"
        } sticky inset-x-0 top-0 w-full transition-all duration-500`}
      >
        <div className="container flex h-14 items-center justify-between overflow-hidden px-4 md:h-16 md:px-6">
          <MainNav items={marketingConfig.mainNav} />
          {/* <nav className="flex items-center gap-3">
            <Link
              href="/login"
              prefetch={true}
              className={cn(
                buttonVariants({ variant: "secondary", size: "sm" }),
                "rounded-full px-5 border border-slate-200 shadow-sm hover:shadow-md transition-all"
              )}
            >
              Login
            </Link>
          </nav> */}
        </div>
      </header>
      <main className="flex-1 z-10">
        {children}
      </main>
      <SiteFooter className="z-40" simpleFooter={false} />
    </div>
  );
}